export default __webpack_public_path__ + "static/latest-6-bd965500d1228604a356a3290814d35e.webp";